import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const SaleApi = {
    fetch: (query) => get(`/sales?${qs.stringify(query)}`),
    fetchById: (id) => get(`/sales/${id}`),
    create: (data) => post('/sales', data),
    update: (id, data) => put(`/sales/${id}`, data),
    delete: (id) => del(`/sales/${id}`),
    receipt: (id, query) => get(`/sales/${id}/receipt?${qs.stringify(query)}`, { responseType: 'blob' }),
};
